module.exports = __webpack_public_path__ + "img/zko2.1dd4506d.jpg";